/**
 * Task 7963 — quando o Minhas Compras oferece o QR Code do Pix (listagem e detalhe do pedido).
 *
 * Quem decide é o Hub: ele só devolve `pixImageQrCodeUrl` enquanto o pedido aguarda pagamento (a mesma
 * trava do `GET me/orders/{id}/pix`). A situação exibida não serve de critério — para pedido do Hub,
 * Pix pendente aparece como "Em processamento", nunca "Pendente", e o botão nunca aparecia.
 *
 * O Pix vence em minutos, mas o pedido segue aguardando pagamento por mais tempo: com a validade no
 * passado o botão some, senão o clique só devolveria "QR code PIX expirado" (410). Sem validade
 * informada o botão fica — o Hub ainda serve esse Pix.
 *
 * @param {{paymentType: string, pixImageQrCodeUrl: ?string, pixValidity: ?string}} order
 * @param {Date} [now] Instante de referência (só os testes informam)
 * @return {boolean}
 */
export function canShowPixQrCode(order, now = new Date()) {
	if (!order || order.paymentType !== 'Pix' || !order.pixImageQrCodeUrl) return false

	return !order.pixValidity || new Date(order.pixValidity) > now
}
